import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
     return (
          <footer id="colophon" className="site-footer">
               <div className="footer1 _relative">
                    <div className="container">
                         <div className="row">
                              <div className="col-lg-4 col-md-6 col-12">
                                   <div className="single-footer-items footer-logo-area">
                                        <div className="footer-logo">
                                             <Link to="/">
                                                  <img
                                                       src="/assets/img/logo/Logo-png-1.webp"
                                                       alt="currency-exchange-api"
                                                  />
                                             </Link>
                                        </div>
                                        <div className="space20" />
                                        <div className="heading1">
                                             <p>
                                                  At IBRLIVE INDIA PRIVATE LIMITED, we're dedicated to delivering innovative
                                                  technology solutions tailored to meet the unique needs of
                                                  businesses like yours.
                                             </p>
                                        </div>
                                        <ul className="social-icon">
                                             <li>
                                                  <a href="https://www.facebook.com/ibrliveindia/">
                                                       <i className="fa-brands fa-facebook-f" />
                                                  </a>
                                             </li>
                                             <li>
                                                  <a href="https://twitter.com/ibr_live">
                                                       <i className="fa-brands fa-x-twitter" />
                                                  </a>
                                             </li>
                                             <li>
                                                  <a href="https://www.linkedin.com/company/ibrlive/">
                                                       <i className="fa-brands fa-linkedin-in" />
                                                  </a>
                                             </li>
                                             <li>
                                                  <a href="https://www.instagram.com/ibrlive/">
                                                       <i className="fa-brands fa-instagram" />
                                                  </a>
                                             </li>
                                        </ul>
                                   </div>
                              </div>
                              <div className="col-lg col-md-6 col-12">
                                   <div className="single-footer-items">
                                        <h3>Service We Offer</h3>
                                        <ul id="menu-footer-services" className="menu-list">
                                             {/* <li
                                                  id="menu-item-29"
                                                  className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-18 current_page_item menu-item-29"
                                             >
                                                  <Link to="/blog">
                                                       Blogs
                                                  </Link>
                                             </li> */}
                                             <li
                                                  id="menu-item-30"
                                                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-30"
                                             >
                                                  <Link to="/aboutus">
                                                       About us
                                                  </Link>
                                             </li>
                                             <li
                                                  id="menu-item-31"
                                                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-31"
                                             >
                                                  <Link to="/plans&pricing">
                                                       Plans &amp; Pricing
                                                  </Link>
                                             </li>
                                        </ul>{" "}
                                   </div>
                              </div>
                              <div className="col-lg col-md-6 col-12">
                                   <div className="single-footer-items">
                                        <h3>Useful Links</h3>
                                        <ul id="menu-footer-links" className="menu-list">
                                             <li
                                                  id="menu-item-32"
                                                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-32"
                                             >
                                                  <Link to="/documentation">
                                                       Documentation
                                                  </Link>
                                             </li>
                                             <li
                                                  id="menu-item-33"
                                                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-33"
                                             >
                                                  <Link to="/supported-pairs">
                                                       Supported Pairs
                                                  </Link>
                                             </li>
                                        </ul>{" "}
                                   </div>
                              </div>
                              <div className="col-lg-3 col-md-6 col-12">
                                   <div className="single-footer-items">
                                        <h3>Contact Us</h3>
                                        {/*<div class="contact-box">*/}
                                        {/*	<div class="icon">*/}
                                        {/*		<img src="<php echo get_stylesheet_directory_uri(); ?>/assets/img/icons/footer1-icon1.png" alt="">*/}
                                        {/*	</div>*/}
                                        {/*	<div class="pera">*/}
                                        {/*		<a href="tel:<php echo esc_attr( get_theme_mod( 'phone1', '0500222333' ) ); ?>"><php echo esc_html( get_theme_mod( 'phone1', '0500 222 333' ) ); ?></a>*/}
                                        {/*	</div>*/}
                                        {/*</div>*/}
                                        <div className="contact-box">
                                             <div className="icon">
                                                  <img
                                                       src="/assets/img/icons/footer1-icon2.png"
                                                       alt=""
                                                  />
                                             </div>
                                             <div className="pera">
                                                  <a href="tel:9817800346">9817800346</a>
                                             </div>
                                        </div>
                                        <div className="contact-box">
                                             <div className="icon">
                                                  <img
                                                       src="/assets/img/icons/footer1-icon3.png"
                                                       alt=""
                                                  />
                                             </div>
                                             <div className="pera">
                                                  <a href="mailto:contact@ibrlive.com">contact@ibrlive.com</a>
                                             </div>
                                        </div>
                                        <div className="contact-box">
                                             <div className="icon">
                                                  <img
                                                       src="/assets/img/icons/footer1-icon4.png"
                                                       alt=""
                                                  />
                                             </div>
                                             <div className="pera">
                                                  <a href="https://ibrlive.com/">https://ibrlive.com/</a>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                         <div className="space40" />
                    </div>
                    <div className="copyright-area">
                         <div className="container">
                              <div className="row align-items-center">
                                   <div className="col-md-4">
                                        <div className="coppyright">
                                             <p>Copyright @2025 Ibrlive. All Rights Reserved</p>
                                        </div>
                                   </div>
                                   <div className="col-md-8">
                                        <div className="coppyright right-area">
                                             <Link to="/terms-conditions">Terms &amp; Conditions</Link>
                                             <Link to="/privacy-policy">Privacy Policy</Link>
                                             <Link to="/pricing-policy">Pricing Policy</Link>
                                             <Link to="/shipping-policy">Shipping Policy</Link>
                                             <Link to="/cancellation-refund-policy">Cancellation/Refund Policy</Link>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>

          </footer>
     )
}

export default Footer;